// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_e7-2";
export var aiChatCartContainerExit = "_e7-4";
export var aiChatContainerLarge = "_e7-0";
export var aiChatContainerSmall = "_e7-1";
export var aiChatIcon = "_e7-6";
export var slideInFromRight = "_e7-3";
export var slideOutToRight = "_e7-5";